
function PathFollower(path, calculator)
{
  // The path to follow
  this.path = path;
  // The calculator which performs the operations
  this.calculator = calculator;
  // size of steps in delta to look along path
  this.granularity = 0.001;
  // the amount of delta to look into the future to generate a target point
  this.lookahead = 0.01;
  // the thickness of the path in pixels
  this.thickness = 5;
  // the minimum number of pixels away the subject can be away form the end point to consider them at the target
  this.buffer = 10;
  // the velocity of the subject used to generate a future point
  this.velocity = 0;
  // the current direction along the path to look
  this.direction = 1;
  // whether to flip the direction of the subject causing it to patrol along the path it's following
  this.cyclic = false;
  // whether to reset the subjects target to the beginning of the path once it reaches the end
  this.reset = false;
  // The minimum amount of force that can be returned
  this.minimum = 0;
  // The maximum amount of force that can be returned
  this.maximum = Number.MAX_VALUE;
  // The current delta along the path
  this.delta = -1;
  // The future point in front of the target
  this.future = calculator.create();
  // The point in front of the subject that it's heading to
  this.ahead = calculator.create();
  // The point where the subject needs to travel to
  this.target = calculator.create();
  // If the subject has reached the destination
  this.destination = false;
}

PathFollower.prototype = 
{
  getForce: function(out, subject)
  {
    var calc = this.calculator;

    this.future = calc.copy( this.future, subject.position );
    this.future = calc.adds( this.future, subject.direction, this.velocity );

    if ( this.delta === -1 )
    {
      this.calculateClosestDelta( 0, 1 );
    }
    else
    {
      var s = this.delta + (this.granularity * this.direction);
      var e = this.delta + (this.lookahead * this.direction);
      var sc = anim8.clamp( s, 0, 1 );
      var ec = anim8.clamp( e, 0, 1 );
      var min = Math.min( sc, ec );
      var max = Math.max( sc, ec );

      this.calculateClosestDelta( min, max );
    }

    this.calculateNextTarget( subject.position );

    this.target = calc.copy( this.target, this.future );
    this.target = calc.sub( this.target, this.ahead );

    var offsetSq = calc.lengthSq( this.target );

    if ( offsetSq > this.thickness * this.thickness && offsetSq !== 0.0 )
    {
      var offset = Math.sqrt( offsetSq );

      this.target = calc.scale( this.target, 1.0 / offset );
      this.target = calc.scale( this.target, this.thickness - ( offset - this.thickness ) );
    }

    this.target = calc.add( this.target, this.ahead );

    out = calc.copy( out, this.target );
    out = calc.sub( out, subject.position );
    var forceLength = calc.length( out );

    if ( forceLength !== 0.0 )
    {
      var forceClamped = anim8.clamp( forceLength, this.minimum, this.maximum );
      out = calc.scale( out, forceClamped / forceLength );  
    }

    return out;
  },
  calculateClosestDelta: function(min, max)
  {
    var calc = this.calculator;
    var path = this.path;
    var p = calc.create();
    var dsq = Number.MAX_VALUE;

    while (min <= max)
    {
      min = Math.min( min, max );

      p = path( p, min );

      var aheadSq = calc.distanceSq( this.future, p );

      if ( aheadSq < dsq )
      {
        this.delta = min;
        dsq = aheadSq;
      }

      min += this.granularity;
    }
  },
  calculateNextTarget: function(away)
  {
    var calc = this.calculator;
    var path = this.path;
    var p = calc.create();
    var velocitySq = this.velocity * this.velocity;
    var awaySq = 0.0;

    while ( this.delta >= 0 && this.delta <= 1 )
    {
      p = path( p, this.delta );

      awaySq = calc.distanceSq( away, p );

      if ( awaySq > velocitySq )
      {
        this.ahead = p;

        return;
      }

      this.delta += this.granularity * this.direction;
    }

    this.delta = anim8.clamp( this.delta, 0, 1 );
    this.ahead = path( this.ahead, this.delta );

    awaySq = calc.distanceSq( away, this.ahead );

    if ( awaySq < this.buffer * this.buffer )
    {
      this.destination = true;

      if ( this.reset )
      {
        this.delta = 1 - this.delta;
        this.ahead = path( this.ahead, this.delta );
      }
      else if ( this.cyclic )
      {
        this.direction = -this.direction;
      }
    }
  }
}; 